// removed by extract-text-webpack-plugin
module.exports = {"td":"td-2sPEn"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/table/table-column/table-column.less
 ** module id = 206
 ** module chunks = 0
 **/